import { Fragment } from 'react';

import PropTypes from 'prop-types';
import copyRequisites from 'utils/copy';

import Tip, { TipPlacement } from 'bloko/blocks/drop/Tip';
import HoverTip from 'bloko/blocks/drop/Tip/HoverTip';

import useTrls from 'hooks/translation/useTrls';

import 'components/Admin/Invoices/InvoicesTable/Invoice/Requisites/Requisites.less';

const Requisites = ({ title, address, post, inn, kpp }) => {
    const trl = useTrls();

    return (
        <Fragment>
            <p data-qa="title">{title}</p>
            {(address || post || inn) && (
                <p>
                    <HoverTip
                        placement={TipPlacement.Top}
                        render={() => (
                            <div>
                                <p>{trl('admin.Invoices.InvoicesTable.Invoice.Requisites.address', [address])}</p>
                                <p>{trl('admin.Invoices.InvoicesTable.Invoice.Requisites.post', [post])}</p>
                                <p>{trl('admin.Invoices.InvoicesTable.Invoice.Requisites.inn', [inn])}</p>
                                {kpp && <p>{trl('admin.Invoices.InvoicesTable.Invoice.Requisites.kpp', [kpp])}</p>}
                            </div>
                        )}
                        host={document.body}
                        DropElement={Tip}
                    >
                        <span
                            className="requisites-link"
                            onClick={() => copyRequisites([address, post, inn, kpp].join(','))}
                        >
                            {trl('admin.Invoices.InvoicesTable.Invoice.requisites')}
                        </span>
                    </HoverTip>
                </p>
            )}
        </Fragment>
    );
};

Requisites.propTypes = {
    title: PropTypes.string,
    address: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.string]),
    post: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.string]),
    inn: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.string]),
    kpp: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.string]),
};

export default Requisites;
